// The number(s) before the slash /, e.g. the '36' in '36/9'
export const secondaryNum = (day, month, year) => (
	Number(month - parseInt(month/10, 10)*9)
	+ Number(day - parseInt(day/10, 10)*9)
	+ Number(year - 9*(parseInt(year/10, 10) + parseInt(year/100, 10) + parseInt(year/1000, 10)))
)

// The number(s) after the slash /, e.g. the '9' in '36/9'
export const primaryNum = (day, month, year) => secondaryNum(day, month, year) - parseInt(secondaryNum(day, month, year)/10, 10)*9

// The first number before the slash /, e.g. the '3' in '36/9'
export const secondaryNum1 = (day, month, year) => secondaryNum(day, month, year) > 9 ? parseInt(secondaryNum(day, month, year)/10, 10) : secondaryNum(day, month, year)

// The second number before the slash /, e.g. the '6' in '36/9'
export const secondaryNum2 = (day, month, year) => secondaryNum(day, month, year) > 9 ? secondaryNum(day, month, year) - parseInt(secondaryNum(day, month, year)/10, 10)*10 : null

// The first number after the slash /, e.g. the '1' in '28/10'
export const primaryNum1 = (day, month, year) => primaryNum(day, month, year) > 9 ? parseInt(primaryNum(day, month, year)/10, 10) : primaryNum(day, month, year)

// The second number after the slash /, e.g. the '0' in '28/10'
export const primaryNum2 = (day, month, year) => primaryNum(day, month, year) > 9 ? primaryNum(day, month, year) - parseInt(primaryNum(day, month, year)/10, 10)*10 : null


export const lifeCycle = ({ day, month }) => {
	const currentYear = new Date().getFullYear()
	const today = new Date(currentYear, new Date().getMonth(), new Date().getDate(), 0, 0, 0)
	const birthday = new Date(currentYear, month-1, day, 0, 0, 0)
	let lifecycle = Number(month - parseInt(month/10, 10)*9)
		+ Number(day - parseInt(day/10, 10)*9)
		+ Number(currentYear - 9*(parseInt(currentYear/10, 10) + parseInt(currentYear/100, 10) + parseInt(currentYear/1000, 10)))
	lifecycle = (today < birthday) ? lifecycle - 1 : lifecycle
	lifecycle = Number(lifecycle - parseInt(lifecycle/10, 10)*9)
	return lifecycle > 9 ? lifecycle - parseInt(lifecycle/10, 10)*9 : lifecycle
}

export const composite = ({ user, contact }) => {
	// Obtain user’s main life path after the forward slash, so 36/9 → 9. Also works if single-digit, since `primaryNum2` is null
	const userPrimary = primaryNum1(user.day, user.month, user.year) + primaryNum2(user.day, user.month, user.year)
	// Obtain contact’s main life path after the forward slash, e.g. 28/10 → 10 → 1
	const contactPrimary = primaryNum1(contact.day, contact.month, contact.year) + primaryNum2(contact.day, contact.month, contact.year)
	return userPrimary + contactPrimary > 12 ? userPrimary + contactPrimary - parseInt((userPrimary + contactPrimary)/10, 10)*9 : userPrimary + contactPrimary
}

